import script from "./Manage.vue?vue&type=script&setup=true&lang=js"
export * from "./Manage.vue?vue&type=script&setup=true&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=5d4e382f&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4e382f"]])

export default __exports__